import React, {useEffect} from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';


const ProductIntro = ({data}) => {
    useEffect(() => {
        AOS.init({
            once:false,
        });
      }, [])


  return (

        <section className='product-intro'>
            <div className='container'>
                <div className='intro-wrap'>
                    <div className='intro-cont'>
                        <h2 className='ttl1'>Introduction</h2>
                        <p dangerouslySetInnerHTML={{ __html: data[0].introContent }}></p>
                    </div>
                    <div className='intro-img'>
                        <img src={data[0].introImg} alt='Introduction' className='' width={474} height={403} />
                    </div>
                </div>
            </div>
        </section>
  )
}

export default ProductIntro